export default class WordVerificator {

  constructor (wordsAsText) {
    window.wordVerificatorGlobal = this;
    this._words = {};
    this._wordsLengthIndex = {};
    this._wordsAsVector = [];

    this.maxLength = 0;

    this.init(wordsAsText);

    // console.log("Longest word: " + this.maxLength )
  }

  init (wordsAsText) {
    var l = 0;
    var w = wordsAsText.split('\r\n');

    for (var i = 0, s = w.length; i < s; i++) {
      var word = w[i];
      this._words[word] = 1;
      this._wordsAsVector.push(word);

      var length = word.length;
      if (length > this.maxLength) this.maxLength = length;
      if (length > l) {
        this._wordsLengthIndex[length] = i;
        l = length
      }
    }
  }

  wordsSorterByLength (w1, w2) {
    var result = 0;

    if (w1.length < w2.length) {
      result = -1
    } else if (w1.length > w2.length) {
      result = 1
    }

    return result
  }

  isWordValid (word) {
    if (word.length < 3) {
      return false
    }
    //else if (word.length >= 6) return true

    var identical = true;
    var hasWildcards = false;
    var ch = word.charAt(0);

    for (var i = 1; i < word.length; i++) {
      var ch1 = word.charAt(i);

      if (ch1 === '*') {
        hasWildcards = true
      }

      if (ch1 !== ch && !(ch === '*' || ch1 === '*')) {
        identical = false
      }
    }

    if (identical) {
      return true
    }

    if (hasWildcards) {
      return getResultWithWildcards(word)
    }

    return this._words[word] !== undefined
  }

  getResultWithWildcards (word) {
    var wordLength = word.length;
    var idxFirst = this._wordsLengthIndex[wordLength];
    var idxLast = this._wordsLengthIndex[wordLength + 1] - 1;

    for (var k = idxFirst; k <= idxLast; k++) {
      var w = this._wordsAsVector[k];
      var isResult = true;

      for (var i = 0; i < wordLength; i++) {
        var ch = w.charAt(i);
        var ch1 = word.charAt(i);

        if (ch !== ch1 && ch1 !== '*') {
          isResult = false;
          break
        }
      }

      if (isResult) {
        return true
      }
    }

    return false
  }

}
